// src/utils/kodeUtils.js

// Ambil semua data dari localStorage berdasarkan key
const getStoredData = (key) => {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : [];
  } catch (err) {
    console.error(`Gagal parse data dari ${key}:`, err);
    return [];
  }
};

// Ambil semua kode karyawan unik dari admin + karyawan
export const getAllUsedKodeKaryawan = () => {
  const admins = getStoredData("admins");
  const karyawans = getStoredData("karyawan");

  const adminKode = admins.map((a) => a.kode).filter(Boolean);
  const karyawanKode = karyawans.map((k) => k.kode).filter(Boolean);

  return [...new Set([...adminKode, ...karyawanKode])]; // hilangkan duplikat
};

// Buat kode baru berdasarkan kode yang sudah dipakai
export const generateKodeKaryawanBaru = () => {
  const allKode = getAllUsedKodeKaryawan();

  const lastNumber =
    allKode
      .map((k) => parseInt(k.split("-")[1]))
      .filter((n) => !isNaN(n))
      .sort((a, b) => b - a)[0] || 0;

  const suggested = lastNumber + 1;
  const kodeBaru = `STN-${String(suggested).padStart(6, "0")}`;

  return {
    kodeList: allKode,
    lastKode: `STN-${String(lastNumber).padStart(6, "0")}`,
    kodeAngka: suggested,
    kodeKaryawan: kodeBaru,
  };
};
